const REVIEW_CATEGORIES = {
	PRODUCT: { DISPLAY: 'Product', URL: 'shop.productdetails' },
	MY_ACCOUNT: { DISPLAY: 'My account', URL: 'shop.myaccount' },
	STORE: { DISPLAY: 'Store', URL: 'shop.locator.store' },
	SHOPPER: { DISPLAY: '', URL: '' }
};

module.exports = REVIEW_CATEGORIES;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/customer-reviews/enums/review-category-enum.js
 **/